import * as domHelpers from "../../scripts/utils/domHelpers.js";

class Checkout {
    constructor() {
        this.wrapSectionHeaders();
        this.wrapDonationButtons();
        this.markupUnstyledLists();
        this.setLayoutClasses();
        this.editPaymentFieldLabels();
    }

    wrapSectionHeaders() {
        document
            .querySelectorAll(".spx-section-container")
            .forEach((section) => {
                const headerElements = section.querySelectorAll(
                    "h2.spx-heading-headline, h2.spx-heading-headline + .spx-link-edit",
                );

                domHelpers.wrapAll(headerElements, {
                    element: "div",
                    className: "spx-section-header",
                });
            });
    }

    wrapDonationButtons() {
        const donationButtons = document.querySelectorAll(
            ".spx-button-primary__checkout--donations, .spx-button-secondary__checkout--donations",
        );

        domHelpers.wrapEach(donationButtons, {
            element: "div",
            className: "Buttons",
        });

        const primaryButton = document.querySelector(
            ".spx-button-primary__checkout--donations",
        );

        if (primaryButton) {
            primaryButton.textContent = "Continue";
            primaryButton.parentElement.appendChild(primaryButton);
        }
    }

    markupUnstyledLists() {
        const unstyledListsSelectors = ["ul"];

        const unstyledLists = document.querySelectorAll(
            unstyledListsSelectors.join(", "),
        );

        unstyledLists.forEach((list) => {
            list.setAttribute("role", "list");
        });
    }

    setLayoutClasses() {
        const proseSectionSelectors = [".spx-section-container"];

        const proseSection = document.querySelectorAll(
            proseSectionSelectors.join(", "),
        );

        proseSection.forEach((list) => {
            list.classList.add("margin-trim");
        });
    }

    editPaymentFieldLabels() {
        const paymentFields = document.querySelectorAll(
            ".PaymentOptions label",
        );

        paymentFields.forEach((field) => {
            const labelText = field.textContent;
            const newLabelText = labelText.replace(":", "");

            field.textContent = newLabelText;
        });

        const requiredLabels = document.querySelectorAll("label.right");

        requiredLabels.forEach((label) => {
            label.classList.add("spx-state-required");
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const pageSelector = document.querySelector(
        ".spx-main-container__checkout",
    );

    if (pageSelector) {
        new Checkout();
    }
});
